import { Star, Trophy } from "lucide-react";
import { CATEGORY_MAP, imgSrc } from "@/lib/categories";

export function TopRated({ items, onOpen }) {
  const top = items.filter((l) => l.review_count > 0)
    .sort((a, b) => b.review_avg - a.review_avg || b.review_count - a.review_count).slice(0, 6);
  if (!top.length) return null;

  return (
    <section data-testid="top-rated-section" className="mb-8">
      <h2 className="text-base md:text-lg font-bold flex items-center gap-2 mb-3"><Trophy className="h-5 w-5 text-[#FFB800]" /> Top rated by travelers</h2>
      <div className="-mx-4 px-4 flex gap-4 overflow-x-auto no-scrollbar pb-2">
        {top.map((l, i) => {
          const cat = CATEGORY_MAP[l.category] || CATEGORY_MAP.shows;
          return (
            <button key={l.id} data-testid={`top-rated-item-${l.id}`} onClick={() => onOpen(l)}
              className="rise card-lift shrink-0 w-64 text-left rounded-2xl overflow-hidden bg-[#151C2C] border border-[#FFB800]/30" style={{ animationDelay: `${i * 50}ms` }}>
              <div className="relative h-28">
                <img src={imgSrc(l.image_url) || cat.img} alt={l.name} className="h-full w-full object-cover" />
                <span className="absolute top-2 left-2 font-mono-vv text-xs font-bold bg-[#FFB800] text-[#0B0F19] px-2 py-0.5 rounded-full">#{i + 1}</span>
              </div>
              <div className="p-3">
                <p className="font-semibold truncate">{l.name}</p>
                <p className="text-sm text-[#FFB800] flex items-center gap-1"><Star className="h-3.5 w-3.5 fill-current" />{l.review_avg}<span className="text-slate-500 text-xs">· {l.review_count} {l.review_count === 1 ? "review" : "reviews"} · {cat.label}</span></p>
              </div>
            </button>
          );
        })}
      </div>
    </section>
  );
}
